import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames/bind";
import styles from "./ManagerLisencePlate.module.css";
import { useParams } from "react-router-dom";
import { useStoreContext } from "../../../hooks/useStoreContext";
import axiosClient from "../../../services/axiosClient";
import { Loading, Toast } from "../../../components";
import { LisencePlateManagerContext } from "../../../contexts";
// import TabBar from "./TabBar";
import { LisencePlate } from "./tabBar1";
import ModalSetting from "../../Administration/Camera/ModalSetting";
import SideBarLisence from "../ViewVideo/Sidebar/SideBarLisence";
import SideBarMangerAPLR from "./Sidebar/SideBarMangerAPLR";
import TabBar from "../../SmartReport/TabBar";

const cx = classNames.bind(styles);
const ManagerLisencePlate = () => {
  const [cameraCode, setCameraCode] = useState();
  const [isShow, setIsShow] = useState(false);
  const [url, setUrl] = useState();
  const [name, setName] = useState();
  const [dataStore, dispatch] = useStoreContext();
  const [tabActive, setTabActive] = useState(0);
  const [timeStart, setTimeStart] = useState(new Date());
  const [timeEnd, setTimeEnd] = useState(new Date());
  const [isSetting, setIsSetting] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [infoCurrentCamera, setInfoCurrentCamera] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const nameService = 'Nhận dạng biển số xe';
  const params = useParams()

  const handleChangeTab = (tabIndex) => {
    setTabActive(tabIndex)
  }

  const getInfoSettingCamera = useCallback(async () => {
    setIsLoading(!isLoading);
    try {
      const res = await axiosClient.get(`/cameraManagement/get-camera-info-by-code/?camera_code=${cameraCode}`);
      setInfoCurrentCamera(res);
      setIsLoading(false);
    } catch (error) {
      Toast.open('Lấy thông tin camera không thành công', 'danger');
      setIsSetting(false);
      setIsLoading(false);
    }
  }, [cameraCode])

  const handleSetting = () => {
    setIsSetting(!isSetting)
    if (cameraCode) {
      getInfoSettingCamera()
    }
  }

  useEffect(() => {
    let code = dataStore.pathNotification.cameraCode;
    let name = dataStore.pathNotification.nameCamera;
    if (code) {
      setCameraCode(code);
      setName(name);
      setTabActive(0);
    }
  }, [dataStore.pathNotification])

  let dataContext = {
    cameraCode,
    setCameraCode,
    isShow,
    setIsShow,
    url,
    setUrl,
    name,
    setName,
    setTimeEnd,
    setTimeStart,
    dispatch,
    dataStore,
    timeEnd,
    timeStart,
    params,
    nameService
  }
  return (
    <LisencePlateManagerContext.Provider
      value={dataContext}
    >
      <div id="__notification"></div>
      <div className={cx("container")}>
        {params.id !== '0' && (
          <div className={cx("slider")}>
            <SideBarMangerAPLR isVideoAI />
          </div>
        )}
        {isLoading ? (
          <div>
            <Loading />
          </div>
        ) : (
          <div className={cx("content")}>
            <div className={cx("header")}>
              <h1 className={cx("title")}>{nameService}</h1>
              <div className={cx('title')}>
                {name}
              </div>
            </div>
            <TabBar
              listTabBar={LisencePlate}
              tabActive={tabActive}
              getTabActive={handleChangeTab}
            />
            {LisencePlate.length > 0 && LisencePlate.map((item) => {
              if (item.tabIndex === tabActive) {
                return (
                  <div key={item.tabIndex}>{item.component}</div>
                )
              } else {
                return (
                  <div key={item.tabIndex}></div>
                )
              }
            })}
          </div>
        )}
      </div>
      {isSetting && cameraCode && infoCurrentCamera && (
        <ModalSetting
          onclose={handleSetting}
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          camera={infoCurrentCamera}
          show={isSetting}
        />
      )}
    </LisencePlateManagerContext.Provider>
  );
};
export default ManagerLisencePlate;
